module.exports = __webpack_public_path__ + "img/materfoundation.7319346.png";